import { UploadOutlined } from '@ant-design/icons'
import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useTranslate } from 'services/utils'
import { isEmptyString } from 'utils'
import { COMPANY_IMG_PLACEHOLDER } from 'utils/constants'
import { client } from 'graphql/client'
import { GET_IMAGE_UPLOAD_URL } from 'graphql/queries/userEntities/userQueries'
import axios from 'axios'
import { handleMutationException } from 'utils/error'
import { Spin, Upload } from 'antd'
import { useMutation } from '@apollo/client'
import { SAVE_PROJECT_COMPANY } from 'graphql/queries/project/projectQueries'
import { updateProjectQueries } from 'services/graphql'
import { companyToInput, projectToInput } from 'graphql/util/inputFunctions'
import NProgress from 'nprogress'

const UploadImage = (props) => {
  const { changeable, overridable, project, user, disableEdit } = props
  const { company } = project
  const { companyLogoURL } = company

  const translate = useTranslate()
  const [saveProjectCompany] = useMutation(SAVE_PROJECT_COMPANY, {
    update: updateProjectQueries('saveProjectCompany'),
  })

  const [uploading, setUploading] = useState(false)

  const save = useCallback(
    (url) => {
      const optimisticResponse = {
        saveProjectCompany: {
          ...project,
          company: {
            ...company,
            companyLogoURL: url,
          },
        },
      }
      const input = projectToInput(project)
      const companyInput = companyToInput({ ...company, companyLogoURL: url })

      NProgress.set(0.7)

      saveProjectCompany({
        optimisticResponse,
        variables: { projectId: project.id, input, companyInput },
      })
        .then(NProgress.done)
        .then(() => setUploading(false))
    },
    [project, company],
  )

  const onUpload = useCallback(
    (file) => {
      NProgress.start()
      setUploading(true)

      const imageExtension = file.name.split('.').pop()

      // Request signed upload URL from backend
      client
        .mutate({
          mutation: GET_IMAGE_UPLOAD_URL,
          variables: {
            id: project.id,
            imageType: 'PROJECT_COMPANY_LOGO',
            imageExtension,
          },
        })
        .then((res) => {
          const { url } = res.data.imageUploadURL

          // Empty request first to intialize the resumable upload
          return axios.put(url, file, {
            headers: {
              'x-goog-resumable': 'start',
              'Content-Type': file.type,
              'Cache-Control': 'public, max-age=0', // Public URL cached for 1 hour otherwise
            },
          })
        })
        .then((res) => {
          const imageURL = res.request.responseURL.split('?')[0]
          save(`${imageURL}?${Math.floor(Date.now() / 1000)}`)
        })
        .catch((err) => {
          setUploading(false)
          handleMutationException(err)
        })
    },
    [user, company],
  )

  if ((!isEmptyString(companyLogoURL) && !overridable) || !changeable) {
    return (
      <div className="image-wrapper non-upload">
        <img
          src={companyLogoURL || COMPANY_IMG_PLACEHOLDER}
          alt={translate('userProfile.companyLogo')}
        />
      </div>
    )
  }

  return (
    <div className={`image-wrapper upload ${disableEdit ? 'disabled' : ''}`}>
      <Upload
        beforeUpload={(file) => {
          onUpload(file)
          return false
        }}
        accept=".png,.jpg,.jpeg"
        disabled={uploading || disableEdit}
        showUploadList={false}
      >
        <img
          src={!isEmptyString(companyLogoURL) ? companyLogoURL : COMPANY_IMG_PLACEHOLDER}
          alt={translate('userProfile.companyLogo')}
        />
        {!disableEdit && (
          <div className="img-text">
            <UploadOutlined /> <FormattedMessage id="clickToChange" />
            {uploading && <Spin size="small" className="ml-1 mr-1" />}
          </div>
        )}
      </Upload>
    </div>
  )
}

export default UploadImage
